module.exports = __webpack_public_path__ + "static/covid-6064d8eb5068bf2ab3e9406205d872c8.jpg";